module.exports = __webpack_public_path__ + "img/wind-turbines.f57bfb10.jpg";